<button mat-icon-button class="close-button" (click)="close()">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<h1 matDialogTitle>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="movtoForm">
      <div fxLayout="row wrap" fxLayout.lt-sm="column">
        <div fxFlex="100" class="pr-1"><br></div>
        <div fxLayout="row wrap" fxLayout.lt-sm="column">

          <div fxFlex="100" class="pr-1">
            <br>
          </div>
         
          
          <div fxFlex="20" class="pr-1">
            <mat-form-field class="full-width">
              <input matInput name="dataInicial" type="date" [(ngModel)]="dataInicial"
                [ngModelOptions]="{standalone: true}" placeholder="Data Inicial" (change)="reloadPageMovto()">
            </mat-form-field>
          </div>
          <div fxFlex="20" class="pr-1">

            <mat-form-field class="full-width">
              <input matInput name="dataFinal" type="date" [(ngModel)]="dataFinal" [ngModelOptions]="{standalone: true}"
                placeholder="Data Final" (change)="reloadPageMovto()">
            </mat-form-field>
          </div>

          <div fxFlex="20" class="pr-1">

            <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedOrdem" (selectionChange)="reloadPageMovto()">
                <mat-option value="NENHUM">Controle</mat-option>
                <mat-option value="TRANSACAO">Transação</mat-option>
                <mat-option value="EMISSAO">Emissão</mat-option>
                <mat-option value="ENTRADA">Entrada/Saída</mat-option>
                <mat-option value="VALOR">Total Docto</mat-option>
                <!-- <mat-option value="LOGIN">Último login</mat-option> -->
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="20" class="pr-1">
            <mat-form-field appearance="fill">
              <mat-label>Ordenar</mat-label>
              <mat-select [(value)]="selectedDirect" (selectionChange)="reloadPageMovto()">
                <mat-option value="ASC">Do Menor para o Maior </mat-option>
                <mat-option value="DESC">Do Maior para o Menor </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="10" class="pr-1">
            <button mat-raised-button color="primary" (click)="reloadPageMovto()">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>

          <div fxFlex="100" class="pr-1">
            <ngx-datatable class="material ml-0 mr-0" [rows]="movtos" [headerHeight]="50" [footerHeight]="50"
              [scrollbarH]="true" [messages]="{emptyMessage:'Nenhuma movimentação encontrada p/ o período'}"
              [limit]="pageSize" [rowHeight]="50">
              <ngx-datatable-column name="#" [width]="25">
                <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                  <strong>{{ rowIndex+1 }}</strong>
                </ng-template>
              </ngx-datatable-column>
              <!-- <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <button mat-icon-button mat-sm-button color="primary" class="mr-1"
                    (click)="$event.preventDefault();openLcto(row.controle)">
                    <mat-icon>edit</mat-icon>
                  </button>
                </ng-template>
              </ngx-datatable-column> -->
              <ngx-datatable-column name="C.S." [flexGrow]="1" [width]="90">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.statuslcto }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column name="Controle" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.controle.toString().padStart(10, '0')}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Emissão" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.emissao | date:'dd/MM/yyyy' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Entrada/Saída" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.dataentradasaida | date:'dd/MM/yyyy' }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Natureza" [flexGrow]="1" [width]="90">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ row?.serieNatureza }}
                </ng-template>
              </ngx-datatable-column>

           

              <ngx-datatable-column name="Número" [flexGrow]="1" [width]="120">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{row?.numeroDocto.toString().padStart(9, '0')}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Transação" [flexGrow]="1" [width]="250" headerClass="text-right">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ (row?.fatTransacaoCodigo??'').toString().padStart(5, '0') +'-'+ row?.fatTransacaoDescricao }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Total" [flexGrow]="1" [width]="120">
                <ng-template ngx-datatable-header-template let-column="column">
                  <div style="text-align:right">
                    <span title="Total do Lançamento">Total</span>
                  </div>
                </ng-template>
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div style="text-align:right">
                    {{ row?.valortotalDocto | currency: 'BRL' }}
                  </div>
                </ng-template>
              </ngx-datatable-column>
              <!-- filialId + filialNomeFantasia -->
              <ngx-datatable-column name="Empresa" [flexGrow]="1" [width]="250">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  {{ (row?.filialId??'').toString().padStart(3, '0') +'-'+ row?.filialNomeFantasia }}
                </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-footer>
                <ng-template ngx-datatable-footer-template>
                  <ng-template #nocontent>
                    <p>Nenhuma movimentação encontrada p/ o período</p>
                  </ng-template>

                  <mat-paginator #paginator [length]="length" fxLayoutAlign="space-around center"
                    [showFirstLastButtons]="true" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent = setPageSizeOptions($event)">
                  </mat-paginator>
                </ng-template>

              </ngx-datatable-footer>
            </ngx-datatable>
          </div>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="mt-1">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon>{{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>